
import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class VesignDataService<T extends any> {
  private TakeActionPendingCount$ = new BehaviorSubject<any>(0);
  TakeActionCount$ = this.TakeActionPendingCount$.asObservable();
  private ViewVendorCompletedDocsCount$ = new BehaviorSubject<any>(0);
  ViewVCompletedDocsCount$ = this.ViewVendorCompletedDocsCount$.asObservable();
  private ViewVendorName$ = new BehaviorSubject<any>(0);
  DisplayVendorName$ = this.ViewVendorName$.asObservable();
  constructor(private http: HttpClient) { 
    
  }

  DocuSignUrl = new Subject;
  TakeActionPendingDocs = new Subject();
  TakeActionActiveTabInfo = new Subject();
  convertHtmlToPdf =  new Subject<any>();
  TakeActionFormHighlignth = new Subject();
  TakeActionEAFValidationDtl = new BehaviorSubject("");
  setTakeActionCount(count: any) {
    this.TakeActionPendingCount$.next(count);
  }

  setVendorViewCompeletedDocsCount(count: any) {
    this.ViewVendorCompletedDocsCount$.next(count);
  }
  setVendorName(name: any) {
    this.ViewVendorName$.next(name);
  }
  Get(url, requestOptions:any): Observable<T> {
    return this.http.get<T>(url,{
      headers: requestOptions
   });
  }
  public response;
  public getAll(url: string): Observable<T[]> {
    return this.http.get<T[]>(url);
  }
  async updateStatus(url){
    return await this.http.get<T>(url).toPromise();
  }
  async GetData(url,data):Promise<any>{
   return await this.http.post(url, data).toPromise();
   // return this.response;
  }
   Post(url, data):Observable<T> {
    return  this.http.post<T>(url, data)
  }

  Put(url, data): Observable<T> {
    return this.http.put<T>(url, data);
  }

  Delete(url): Observable<T> {
    return this.http.delete<T>(url);
  }

  GetFile(url, requestOptions:any): Observable<T> {
    return this.http.get<T>(url,{
      headers: requestOptions
   });
  }

  sendClickEvent()
  {
    this.convertHtmlToPdf.next();
  }
  getClickEvent() : Observable<any>
  {
    return this.convertHtmlToPdf.asObservable();
  }

  Vectorkey: string = 'e84ad660c4721ae0e84ad660c4721ae0'
  Skey: string = 'CollaberaConect'
  Saltkey: string = 'CollaberaConectSalt'
 
  //Creating the Vector Key
  iv: string = CryptoJS.enc.Hex.parse(this.Vectorkey);
  //Encoding the Password in from UTF8 to byte array
  Pass: string = CryptoJS.enc.Utf8.parse(this.Skey);
  //Encoding the Salt in from UTF8 to byte array
  Salt: string = CryptoJS.enc.Utf8.parse(this.Saltkey);
  //Creating the key in PBKDF2 format to be used during the decryption
  key128Bits1000Iterations: string = CryptoJS.PBKDF2(String(CryptoJS.enc.Utf8), this.Salt, { keySize: 128 / 32, iterations: 1000 });
 
  encryptedKey: any = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse("sahi.ram"), this.key128Bits1000Iterations,
    { mode: CryptoJS.mode.CBC, iv: this.iv, padding: CryptoJS.pad.Pkcs7 });
 
 
  AuthToken: string = "";
  GetAuthToken(): Observable<T> {
    debugger;
    const Vectorkey = 'e84ad660c4721ae0e84ad660c4721ae0'
    const Skey = 'CollaberaConect'
    const Saltkey = 'CollaberaConectSalt'
    var obj = {
      "VendorCode": sessionStorage.getItem("VendorCode"),
      "AuthorizationKey": "53c567cc-e5b8-411d-989a-559787634578"
    }
 
    //Creating the Vector Key
    var iv = CryptoJS.enc.Hex.parse(Vectorkey);
    //Encoding the Password in from UTF8 to byte array
    var Pass = CryptoJS.enc.Utf8.parse(Skey);
    //Encoding the Salt in from UTF8 to byte array
    var Salt = CryptoJS.enc.Utf8.parse(Saltkey);
    //Creating the key in PBKDF2 format to be used during the decryption
    var key128Bits1000Iterations = CryptoJS.PBKDF2(Pass.toString(CryptoJS.enc.Utf8), Salt, { keySize: 128 / 32, iterations: 1000 });
 
    var encryptedKey = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(obj)), key128Bits1000Iterations,
      { mode: CryptoJS.mode.CBC, iv: iv, padding: CryptoJS.pad.Pkcs7 });
 
    // console.log(encryptedKey.toString());    
    var obj2 = {
      "enydata": String(encryptedKey)
    }
 
    return this.http.post<T>(environment.eSignApiUrl + "/api/TakeAction/GetJwtToken",obj2);
  }
}


